import styled from 'styled-components';
import { COLORS } from '../../../constants/style/color';
import { rem } from '../../../utils/style';

export const ToolWrapper = styled.div`
  .section-card {
    background: ${COLORS.White};
    border: 1px solid ${COLORS.CulturedWhite};
    border-radius: ${rem(6)};
    padding: ${rem(20)} ${rem(24)};
    margin-bottom: ${rem(16)};
    box-shadow: 0px 2px 7px ${COLORS.CardShadow};
  }

  .section-title {
    font-size: ${rem(16)};
    font-weight: 600;
    color: ${COLORS.Blue};
    margin-bottom: ${rem(12)};
  }
`;

export const ParticipantBar = styled.div<{ $columns?: 2 | 3 }>`
  display: grid;
  grid-template-columns: ${({ $columns = 3 }) =>
    $columns === 2 ? '1fr 1fr' : '1fr 1fr 1fr'};
  gap: ${rem(12)};
  align-items: end;

  @media (max-width: 1024px) {
    grid-template-columns: ${({ $columns = 3 }) => ($columns === 2 ? '1fr 1fr' : '1fr 1fr')};
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ParticipantInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${rem(16)};
  margin-top: ${rem(12)};
  padding: ${rem(10)} ${rem(16)};
  background: ${COLORS.OffWhite};
  border-radius: ${rem(4)};

  .info-item {
    display: flex;
    flex-direction: column;
    gap: ${rem(2)};

    .info-label {
      font-size: ${rem(12)};
      font-weight: 500;
      color: ${COLORS.Gray};
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    .info-value {
      font-size: ${rem(14)};
      font-weight: 600;
      color: ${COLORS.Blue};
    }
  }
`;

export const SellShareTable = styled.div`
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: ${rem(13)};

    thead {
      background: ${COLORS.OffWhite};

      th {
        padding: ${rem(10)} ${rem(10)};
        text-align: left;
        font-weight: 600;
        font-size: ${rem(12)};
        color: ${COLORS.Gray};
        text-transform: uppercase;
        white-space: nowrap;
        border-bottom: 2px solid ${COLORS.LightGray};
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid ${COLORS.CulturedWhite};
        transition: background 0.15s;

        &:hover {
          background: ${COLORS.OffWhite};
        }

        &.error-row {
          background: #fff5f5;
        }
      }

      td {
        padding: ${rem(8)} ${rem(10)};
        vertical-align: middle;
        white-space: nowrap;
      }
    }
  }

  .record-badge {
    display: inline-block;
    padding: ${rem(2)} ${rem(8)};
    border-radius: ${rem(3)};
    font-size: ${rem(11)};
    font-weight: 600;
    background: #e0e7ff;
    color: #3730a3;
  }

  .row-error {
    color: ${COLORS.Red};
    font-size: ${rem(12)};
    padding: ${rem(4)} ${rem(10)};
  }

  .sell-input {
    width: ${rem(80)};
    padding: ${rem(8)} ${rem(10)};
    border: 1px solid ${COLORS.LightGray};
    border-radius: ${rem(6)};
    font-size: ${rem(14)};
    height: ${rem(38)};
    text-align: right;
    box-shadow: ${rem(0)} ${rem(2)} ${rem(4)} ${COLORS.DefaultShadow};
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: ${COLORS.Purple};
    }

    &.has-error {
      border-color: ${COLORS.Red};
    }
  }

  .inline-select {
    padding: ${rem(3)} ${rem(4)};
    border: 1px solid ${COLORS.LightGray};
    border-radius: ${rem(4)};
    font-size: ${rem(11)};
    background: ${COLORS.White};
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: ${COLORS.Purple};
    }
  }

  .award-badge {
    display: inline-block;
    padding: ${rem(2)} ${rem(6)};
    border-radius: ${rem(3)};
    font-size: ${rem(11)};
    font-weight: 600;

    &.iso {
      background: #dbeafe;
      color: #1e40af;
    }
    &.nqso {
      background: #fef3c7;
      color: #92400e;
    }
    &.rsu {
      background: #d1fae5;
      color: #065f46;
    }
    &.psu {
      background: #ede9fe;
      color: #5b21b6;
    }
    &.espp {
      background: #fce7f3;
      color: #9d174d;
    }
  }

  .action-btn {
    padding: ${rem(8)} ${rem(16)};
    border: none;
    border-radius: ${rem(4)};
    font-size: ${rem(13)};
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.15s;

    &:hover {
      opacity: 0.85;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &.submit-btn {
      background: ${COLORS.Purple};
      color: ${COLORS.White};
    }

    &.fill-btn {
      background: #047857;
      color: ${COLORS.White};
    }
  }

  .error-text {
    font-size: ${rem(12)};
    color: ${COLORS.Red};
  }

  .estimated-value {
    font-weight: 500;
    color: ${COLORS.Blue};
  }

  .max-shares {
    font-size: ${rem(13)};
    color: ${COLORS.Gray};
    font-weight: 500;
  }
`;

export const HistoryTable = styled.div`
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: ${rem(13)};

    thead {
      background: ${COLORS.OffWhite};

      th {
        padding: ${rem(10)} ${rem(10)};
        text-align: left;
        font-weight: 600;
        font-size: ${rem(12)};
        color: ${COLORS.Gray};
        text-transform: uppercase;
        white-space: nowrap;
        border-bottom: 2px solid ${COLORS.LightGray};

        &.sortable {
          cursor: pointer;
          user-select: none;

          &:hover {
            color: #333;
          }
        }

        .th-content {
          display: inline-flex;
          align-items: center;
          gap: ${rem(2)};
        }

        .sort-icons {
          display: inline-flex;
          flex-direction: column;
          line-height: 0;
          margin-left: ${rem(2)};

          .material-symbols-rounded {
            font-size: ${rem(16)};
            line-height: ${rem(10)};
            color: ${COLORS.LightGray};
            transition: color 0.15s;

            &.active {
              color: #7c3aed;
            }
          }
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid ${COLORS.CulturedWhite};
      }

      td {
        padding: ${rem(8)} ${rem(10)};
        vertical-align: middle;
        white-space: nowrap;
      }
    }
  }

  .record-badge {
    display: inline-block;
    padding: ${rem(2)} ${rem(8)};
    border-radius: ${rem(3)};
    font-size: ${rem(11)};
    font-weight: 600;
    background: #e0e7ff;
    color: #3730a3;
  }

  .booking-badge {
    display: inline-block;
    padding: ${rem(2)} ${rem(8)};
    border-radius: ${rem(3)};
    font-size: ${rem(11)};
    font-weight: 600;
    background: #f3e8ff;
    color: #6b21a8;
  }

  .status-badge {
    display: inline-block;
    padding: ${rem(2)} ${rem(8)};
    border-radius: ${rem(10)};
    font-size: ${rem(12)};
    font-weight: 600;

    &.pending {
      background: #fef3c7;
      color: #92400e;
    }
    &.filled {
      background: #d1fae5;
      color: #065f46;
    }
    &.reversed {
      background: #fee2e2;
      color: #991b1b;
    }
  }

  .cancel-link {
    color: ${COLORS.Red};
    font-size: ${rem(13)};
    font-weight: 600;
    cursor: pointer;
    background: none;
    border: none;
    text-decoration: underline;

    &:hover {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
`;

export const ModalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${rem(12)} ${rem(16)};
  margin-bottom: ${rem(16)};

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  .field-group {
    display: flex;
    flex-direction: column;
    gap: ${rem(4)};

    label {
      font-size: ${rem(11)};
      font-weight: 500;
      color: ${COLORS.Gray};
      text-transform: uppercase;
    }

    .field-value {
      font-size: ${rem(13)};
      font-weight: 600;
      color: ${COLORS.Blue};
      padding: ${rem(6)} 0;
    }

    input,
    select {
      padding: ${rem(6)} ${rem(8)};
      border: 1px solid ${COLORS.LightGray};
      border-radius: ${rem(4)};
      font-size: ${rem(13)};

      &:focus {
        outline: none;
        border-color: ${COLORS.Purple};
      }
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${rem(12)};
  padding-top: ${rem(16)};
  border-top: 1px solid ${COLORS.CulturedWhite};
`;

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(10)};
  align-items: end;
  padding: ${rem(12)} 0;
  margin-bottom: ${rem(8)};
  border-bottom: 1px solid ${COLORS.CulturedWhite};

  .filter-item {
    min-width: ${rem(150)};
    max-width: ${rem(200)};
  }

  .filter-date {
    min-width: ${rem(140)};

    input {
      padding: ${rem(6)} ${rem(8)};
      border: 1px solid ${COLORS.LightGray};
      border-radius: ${rem(4)};
      font-size: ${rem(13)};
      height: ${rem(36)};
      width: 100%;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: ${COLORS.Purple};
      }
    }

    label {
      display: block;
      font-size: ${rem(11)};
      font-weight: 600;
      color: ${COLORS.Gray};
      text-transform: uppercase;
      margin-bottom: ${rem(4)};
    }
  }

  .filter-clear {
    font-size: ${rem(12)};
    color: ${COLORS.Red};
    cursor: pointer;
    font-weight: 600;
    background: none;
    border: none;
    padding: ${rem(8)} ${rem(4)};
    text-decoration: underline;

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const ActingOnBehalfBanner = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  padding: ${rem(10)} ${rem(16)};
  margin-bottom: ${rem(16)};
  background: #eff6ff;
  border: 1px solid #93c5fd;
  border-radius: ${rem(6)};
  font-size: ${rem(13)};
  color: #1e40af;

  .banner-icon {
    font-size: ${rem(20)};
    color: #3b82f6;
  }

  .banner-name {
    font-weight: 700;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: ${rem(24)} 0;
  color: ${COLORS.Gray};
  font-size: ${rem(14)};
`;

export const TabBar = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 2px solid ${COLORS.CulturedWhite};
  margin-bottom: ${rem(16)};
`;

export const TabItem = styled.button<{ $active?: boolean }>`
  padding: ${rem(10)} ${rem(20)};
  font-size: ${rem(14)};
  font-weight: 600;
  color: ${({ $active }) => ($active ? COLORS.Blue : COLORS.Gray)};
  background: none;
  border: none;
  border-bottom: 2px solid ${({ $active }) => ($active ? COLORS.Blue : 'transparent')};
  margin-bottom: -2px;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: ${COLORS.Blue};
  }
`;
